import { render, staticRenderFns } from "./payrollDetail.vue?vue&type=template&id=4e30e189&scoped=true"
import script from "./payrollDetail.vue?vue&type=script&lang=js"
export * from "./payrollDetail.vue?vue&type=script&lang=js"
import style0 from "./payrollDetail.vue?vue&type=style&index=0&id=4e30e189&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e30e189",
  null
  
)

export default component.exports